import React from "react";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import Authorize from "../../utilities/Authorize";
import authUtility from '../../utilities/AuthUtility';
import getLicenseDetailsStore from "../../flux/stores/license/GetLicenseDetailsStore";
import licenseActions from "../../flux/actions/LicenseActions";


export default class ConfigurationCard extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isModuleClick: true,
      isAccManage: false,
      isUtility: false,
      licenseDetails: [],
      isLicenseApplicable: false,
    };
  }

  onModuleHeader = () => {
    this.setState({
      isAccManage: false,
      isUtility: false,
      isModuleClick: true,
    });
  };
  onAccManageHeader = () => {
    this.setState({
      isModuleClick: false,
      isUtility: false,
      isAccManage: true,
    });
  };
  onUtilityHeader = () => {
    this.setState({
      isModuleClick: false,
      isAccManage: false,
      isUtility: true,
    });
  };
  componentDidMount() {
    getLicenseDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this.setState({ licenseDetails: state.licenseData.data });
    });
    if (window.location.pathname.toString().includes("utility")) {
      this.setState({
        isModuleClick: false,
        isAccManage: false,
        isUtility: true,
      });
    } else if (window.location.pathname.toString().includes("accountmanagement")) {
      this.setState({
        isModuleClick: false,
        isAccManage: true,
        isUtility: false,
      });
    } else {
      this.setState({
        isModuleClick: true,
        isAccManage: false,
        isUtility: false,
      });
    }
    this.getLicenseData();
    
  }

  getLicenseData = () => {
    licenseActions
      .getLicenseDetails()
      .then(async () => {
        const isAnyLicenseNotApplicable = this.state.licenseDetails.some((node:any) => !node.isLicenseApplicable);
        // let responses: any = await import('../../../public/test.json');
        // let isAnyLicenseNotApplicable: any = responses.default.some((node: any) => !node.isLicenseApplicable);
        if (isAnyLicenseNotApplicable) {
          this.setState({ isLicenseApplicable: false });
        } else {
          this.setState({ isLicenseApplicable: true });
        }
      })
      .catch((error) => {
        console.log("License Management error", error);
      });
  }

  render() {
    return (
      <Translation>
        {(t) => (
          <div className="configCard">
            <div className="row" style={{ marginLeft: "5px" }}>
              <div className="col-md-4 col-lg-4 col-xl-4 cardHeader">
                <ul className="navbar-nav">
                  {authUtility.hasPermission([`${CONSTANTS.AUTHKEY_PROPERTY}`,
                  `${CONSTANTS.AUTHKEY_INSTRUMENT_TYPE}`,`${CONSTANTS.AUTHKEY_INSTRUMENT}`,
                  `${CONSTANTS.AUTHKEY_SOURCE}`,`${CONSTANTS.AUTHKEY_TEST_PLAN}`,
                  `${CONSTANTS.AUTHKEY_GRADE}`,`${CONSTANTS.AUTHKEY_PRODUCT}`,`${CONSTANTS.AUTHKEY_INSTRUMENT_STATION}`]) &&
                    <li>
                      <a
                        href="#/"
                        onClick={this.onModuleHeader}
                        className={
                          this.state.isModuleClick
                            ? "active headerModuel"
                            : "headerModuel"
                        }
                      >
                        {t(CONSTANTS.MENU_MODULES)}
                      </a>
                    </li>
                  }
                  {authUtility.hasPermission([`${CONSTANTS.AUTHKEY_ROLES}`,`${CONSTANTS.AUTHKEY_USERS}`]) &&              
                    <li><a href="#/" onClick={this.onAccManageHeader}
                        className={this.state.isAccManage ? "active headerModuel" : "headerModuel"}>{t(CONSTANTS.MENU_ACCOUNT_MANAGEMENT)}</a>
                    </li>
                  }
                  {authUtility.hasPermission([`${CONSTANTS.AUTHKEY_SETTINGS}`,`${CONSTANTS.AUTHKEY_SCANNER}`,`${CONSTANTS.AUTHKEY_BACKUP_RESTORE}`]) &&
                    <li>
                      <a
                        href="#/"
                        onClick={this.onUtilityHeader}
                        className={
                          this.state.isUtility
                            ? "active headerModuel"
                            : "headerModuel"
                        }
                      >
                        {t(CONSTANTS.MENU_UTILITY)}
                      </a>
                    </li>
                  }
                </ul>
              </div>
              {this.state.isModuleClick ? (
                <>
                  <div className="col-md-4 col-lg-4 col-xl-4 cardBody">
                    <ul className="navbar-nav">
                      <Authorize scopes={[`${CONSTANTS.AUTHKEY_PROPERTY}`]}>
                        <li>
                          <a href="/property">{t(CONSTANTS.MENU_PROPERTY)}</a>
                        </li>
                      </Authorize>
                      <Authorize scopes={[`${CONSTANTS.AUTHKEY_INSTRUMENT_TYPE}`]}>
                        <li>
                          <a href="/manageinstrument/instrumenttype">
                            {t(CONSTANTS.SUBMENU_INSTRUMENT_TYPE)}
                          </a>
                        </li>
                      </Authorize>
                      <Authorize scopes={[`${CONSTANTS.AUTHKEY_INSTRUMENT}`]}>
                        <li>
                          <a href="/manageinstrument/instrument">
                            {t(CONSTANTS.SUBMENU_INSTRUMENT)}
                          </a>
                        </li>
                      </Authorize>
                      <Authorize scopes={[`${CONSTANTS.AUTHKEY_SOURCE}`]}>
                        <li>
                          <a href="/source">{t(CONSTANTS.MENU_SOURCE)}</a>
                        </li>
                      </Authorize>
                    </ul>
                  </div>
                  <div className="col-md-4 col-lg-4 col-xl-4 cardBody">
                    <ul className="navbar-nav">
                      <Authorize scopes={[`${CONSTANTS.AUTHKEY_TEST_PLAN}`]}>
                        <li>
                          <a href="/manageinstrument/testplan">
                            {t(CONSTANTS.MODULE_TESTPLAN)}
                          </a>
                        </li>
                      </Authorize>
                      <Authorize scopes={[`${CONSTANTS.AUTHKEY_GRADE}`]}>
                        <li>
                          <a href="/grade">{t(CONSTANTS.MODULE_GRADE)}</a>
                        </li>
                      </Authorize>
                      <Authorize scopes={[`${CONSTANTS.AUTHKEY_PRODUCT}`]}>
                        <li>
                          <a href="/product">{t(CONSTANTS.MODULE_PRODUCT)}</a>
                        </li>
                      </Authorize>
                      <Authorize scopes={[`${CONSTANTS.AUTHKEY_INSTRUMENT_STATION}`]}>
                        <li>
                          <a href="/manageinstrument/instrumentstation">
                            {t(CONSTANTS.SUBMENU_INSTRUMENT_STATION)}
                          </a>
                        </li>
                      </Authorize>
                    </ul>
                  </div>
                </>
              ) : (
                ""
              )}
              {this.state.isAccManage ? (
                <div className="col-md-4 col-lg-4 col-xl-4 cardBody">
                  <ul className="navbar-nav">
                  <Authorize scopes={[`${CONSTANTS.AUTHKEY_USERS}`]}>
                    <li>
                      <a href="/accountmanagement/users">
                        {t(CONSTANTS.MODULE_USERS)}
                      </a>
                    </li>
                  </Authorize>
                  <Authorize scopes={[`${CONSTANTS.AUTHKEY_ROLES}`]}>
                    <li>
                      <a href="/accountmanagement/rolesandpermissions">
                        {t(CONSTANTS.MODULE_ROLES_AND_PERMISSIONS)}
                      </a>
                    </li>
                  </Authorize>
                  </ul>
                </div>
              ) : (
                ""
              )}
              {this.state.isUtility ? (
                <div className="col-md-8 col-lg-8 col-xl-8 cardBody">
                  <ul className="navbar-nav">
                    <Authorize scopes={[`${CONSTANTS.AUTHKEY_SETTINGS}`]}>
                      <li>
                        <a href="/utility/Settings">
                          {t(CONSTANTS.SUBMENU_SETTINGS)}
                        </a>
                      </li>
                    </Authorize>
                    <Authorize scopes={[`${CONSTANTS.AUTHKEY_SCANNER}`]}>
                      <li>
                        <a href="/utility/scanner">
                          {t(CONSTANTS.SUBMENU_SCANNER)}
                        </a>
                      </li>
                    </Authorize>
                    <Authorize scopes={[`${CONSTANTS.AUTHKEY_BACKUP_RESTORE}`]}>
                    <li>
                      <a href="/utility/backupandrestore">
                        {t(CONSTANTS.SUBMENU_BACKUP_AND_RESTORE)}
                      </a>
                    </li>
                    </Authorize>
                    <Authorize scopes={[`${CONSTANTS.AUTHKEY_LOGS}`]}>
                    <li>
                      <a href="/utility/Logs">
                        {t(CONSTANTS.SUBMENU_LOGS)}
                      </a>
                    </li>
                    </Authorize>
                    {this.state.isLicenseApplicable && <Authorize scopes={[`${CONSTANTS.AUTHKEY_LICENSE_MANAGEMENT}`]}>
                    <li>
                      <a href="/utility/LicenseManagement">
                        {t(CONSTANTS.SUBMENU_LICENSE_MANAGEMENT)}
                      </a>
                    </li>
                    </Authorize>}
                  </ul>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
